import { WorkTypeDesired } from "../WorkTypeDesired";

export const WorkTypeDesiredLabels: Record<WorkTypeDesired, string> = {
  [WorkTypeDesired.CasualWorkOnly]: "Casual Work Only",
  [WorkTypeDesired.CasualWorkWhileLookingForPermanentPosition]:
    "Casual Work While Looking For Permanent Position",
  [WorkTypeDesired.PermanentPositionOnly]: "Permanent Position Only",
};
